let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("e3W7Y")).then(() => parcelRequire('72lMw'));